import { useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { AiOutlineClose } from 'react-icons/ai';
import { MdCheckCircle, MdCancel } from 'react-icons/md';
import SportIcon from '../SportIcon/SportIcon';
import useQuizAttempt from '../../hooks/quiz/useQuizAttempt';
import globalButtonStyles from '../../styles/ButtonGradient.module.css';
import styles from './ViewQuizDetailsButton.module.css';

const ViewQuizDetailsButton = ({ attemptId }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { fetchAttempt, attempt, loading, error } = useQuizAttempt();

  const handleOpen = async () => {
    setIsOpen(true);
    await fetchAttempt({ variables: { attemptId } });
  };

  const handleClose = () => setIsOpen(false);

  const isCorrect = (q) => q.userAnswer === q.correctAnswer;

  const modal = (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className={styles.modalOverlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className={styles.modalContent}
            initial={{ scale: 0.95, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.95, opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <button className={styles.closeIcon} onClick={handleClose}>
              <AiOutlineClose size={24} />
            </button>

            {loading && <p>Loading...</p>}
            {error && <p>Error loading attempt.</p>}

            {attempt && (
              <>
                <h3 className={styles.attemptTitle}>
                  <SportIcon sport={attempt.sport} />
                  {attempt.sport.charAt(0).toUpperCase() + attempt.sport.slice(1)} Level {attempt.level}
                </h3>
                <div className={styles.questionList}>
                  {attempt.questions.map((q, i) => (
                    <div key={i} className={styles.questionItem}>
                      <div className={styles.questionHeader}>
                        {isCorrect(q) ? (
                          <MdCheckCircle size={20} className={styles.correct} />
                        ) : (
                          <MdCancel size={20} className={styles.incorrect} />
                        )}
                        <p className={styles.questionText}>{q.questionText}</p>
                      </div>
                      <p><strong>Your Answer:</strong> {q.userAnswer}</p>
                      {!isCorrect(q) && (
                        <p><strong>Correct Answer:</strong> {q.correctAnswer}</p>
                      )}
                    </div>
                  ))}
                </div>
              </>
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );

  return (
    <>
      <button className={globalButtonStyles.button} onClick={handleOpen}>
        View Details
      </button>
      {createPortal(modal, document.getElementById('modal-root'))}
    </>
  );
};

export default ViewQuizDetailsButton;